// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../assets/stylesheets/variables.css\"","paddedForNavbar":"_15-uIrn7gODHiOpUuDWjwC","title":"_2IbHD4FVxtBnbNHEUw2mS3","errorRed":"#ff2a2a","genericContainer":"_2ELtkcMpIJZ1yyH_kfj3I7","body":"_2lYHSCAcM6vA2s-47YYZeS","extraSmallMaxWidth":"767px","container":"_32_2Zqk1rTUeu_j-GPEDHo _15-uIrn7gODHiOpUuDWjwC","spinner":"_2QxxjJhdaCwKLPlTPsuJZQ","errorContainer":"jJtjF68_jHYcTWvuNd5MQ _2ELtkcMpIJZ1yyH_kfj3I7","compareError":"_3t9TUa0vJlEaUSglG1QNCg _2lYHSCAcM6vA2s-47YYZeS"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/compare/Compare.css
// module id = 1095
// module chunks = 1